// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 904 ? "665031a6" : chunkId) + "." + {"363":"2160c04fe3bd746f","734":"ed2a8691a8b640af","830":"35b0d1381925f79b","904":"777d167d16164f90"}[chunkId] + ".js";
};